import { render } from "./User.vue?vue&type=template&id=6a08c710"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"
script.render = render

export default script